module.exports = __webpack_public_path__ + "img/开封市.c31741f9.png";